import { useEffect, RefObject } from "react";

const useOutsideClick = (
  refs: Array<RefObject<HTMLElement>>,
  callback: (event: MouseEvent) => void
) => {
  const listener = (event: MouseEvent) => {
    const modal = document.querySelector('[data-tag="custom-modal"]');
    const isInteractiveElement =
      (event.target as HTMLElement)?.tagName === "TEXTAREA" || (event.target as HTMLElement)?.tagName === "INPUT";

      const isInsideModal = modal?.contains(event.target as Node);

    if (isInteractiveElement || isInsideModal) return;

    const isOutside = refs.every(
      (ref) => !ref.current || !ref.current.contains(event.target as Node)
    );

    if (isOutside) {
      callback(event);
    }
  };

  useEffect(() => {
    document.addEventListener("click", listener);

    return () => {
      document.removeEventListener("click", listener);
    };
  }, [refs, callback]);
};

export default useOutsideClick;